import styled, { CreateStyled } from '@emotion/styled/macro';

import { Theme } from '.';

export default styled as CreateStyled<Theme>;
